!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("tinacms"), require("react-dismissible"), require("react-final-form"), require("styled-components"), require("@tinacms/styles"), require("@tinacms/icons"), require("react-textarea-autosize"), require("react-dropzone"), require("react-beautiful-dnd"), require("@tinacms/react-forms")) : "function" == typeof define && define.amd ? define(["exports", "react", "tinacms", "react-dismissible", "react-final-form", "styled-components", "@tinacms/styles", "@tinacms/icons", "react-textarea-autosize", "react-dropzone", "react-beautiful-dnd", "@tinacms/react-forms"], e) : e((n = n || self)["react-tinacms-inline"] = {}, n.React, n.tinacms, n.reactDismissible, n.reactFinalForm, n.styled, n.styles, n.icons, n.TextareaAutosize, n.reactDropzone, n.reactBeautifulDnd, n.reactForms);
}(this, function (n, A, W, l, c, t, d, H, e, s, u, o) {
  "use strict";

  var f = "default" in A ? A.default : A,
      i = "default" in t ? t.default : t;
  e = e && e.hasOwnProperty("default") ? e.default : e;

  var _m = function m() {
    return (_m = Object.assign || function (n) {
      for (var e, t = 1, o = arguments.length; t < o; t++) {
        for (var i in e = arguments[t]) {
          Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function v(t, o) {
    var i,
        r,
        a,
        n,
        l = {
      label: 0,
      sent: function sent() {
        if (1 & a[0]) throw a[1];
        return a[1];
      },
      trys: [],
      ops: []
    };
    return n = {
      next: e(0),
      throw: e(1),
      return: e(2)
    }, "function" == typeof Symbol && (n[Symbol.iterator] = function () {
      return this;
    }), n;

    function e(e) {
      return function (n) {
        return function (e) {
          if (i) throw new TypeError("Generator is already executing.");

          for (; l;) {
            try {
              if (i = 1, r && (a = 2 & e[0] ? r.return : e[0] ? r.throw || ((a = r.return) && a.call(r), 0) : r.next) && !(a = a.call(r, e[1])).done) return a;

              switch (r = 0, a && (e = [2 & e[0], a.value]), e[0]) {
                case 0:
                case 1:
                  a = e;
                  break;

                case 4:
                  return l.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  l.label++, r = e[1], e = [0];
                  continue;

                case 7:
                  e = l.ops.pop(), l.trys.pop();
                  continue;

                default:
                  if (!(a = 0 < (a = l.trys).length && a[a.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    l = 0;
                    continue;
                  }

                  if (3 === e[0] && (!a || e[1] > a[0] && e[1] < a[3])) {
                    l.label = e[1];
                    break;
                  }

                  if (6 === e[0] && l.label < a[1]) {
                    l.label = a[1], a = e;
                    break;
                  }

                  if (a && l.label < a[2]) {
                    l.label = a[2], l.ops.push(e);
                    break;
                  }

                  a[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }

              e = o.call(t, l);
            } catch (n) {
              e = [6, n], r = 0;
            } finally {
              i = a = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, n]);
      };
    }
  }

  function r(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  var p = A.createContext(null);

  function _() {
    var n = A.useContext(p);
    if (!n) throw new Error("useInlineForm must be within an InlineFormContext");
    return n;
  }

  var L = f.createContext({});

  function g(n) {
    var e = n.name,
        t = n.parse,
        o = n.format,
        i = n.children,
        r = _(),
        a = e,
        l = A.useContext(L);

    return l.name && (a = l.name + "." + e), A.createElement(c.Field, {
      name: a,
      parse: t,
      format: o
    }, function (n) {
      return i(_m(_m({}, n), r));
    });
  }

  function G(n) {
    function a(n) {
      return "function" == typeof n ? n() : n;
    }

    var l = n.blocks,
        c = n.addBlock,
        e = n.position,
        t = n.index,
        o = n.offset,
        i = A.useState(!1),
        r = i[0],
        s = i[1],
        d = A.useRef(null),
        u = A.useState(!1),
        f = u[0],
        p = u[1];
    return A.useEffect(function () {
      function n() {
        return s(!1);
      }

      return document.addEventListener("mouseup", n, !1), function () {
        return document.removeEventListener("mouseup", n);
      };
    }, []), A.createElement(S, {
      index: t,
      offset: o,
      position: e,
      isOpen: r
    }, A.createElement(j, {
      ref: d,
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault();
        var e = d.current;

        if (null !== e) {
          var t = e.getBoundingClientRect(),
              o = (window.innerHeight || document.documentElement.clientHeight) / 2,
              i = t.top;
          p(!(i < o));
        }

        if (1 == Object.keys(l).length) {
          var r = Object.keys(l)[0];
          c(_m({
            _template: r
          }, a(l[r].template.defaultItem)));
        } else s(function (n) {
          return !n;
        });
      },
      isOpen: r,
      primary: !0,
      small: !0
    }, A.createElement(H.AddIcon, null)), A.createElement(D, {
      openTop: f,
      isOpen: r
    }, Object.keys(l).map(function (e) {
      var t = l[e].template;
      return t ? A.createElement(O, {
        key: null == t ? void 0 : t.label,
        onClick: function onClick(n) {
          n.stopPropagation(), n.preventDefault(), c(_m({
            _template: e
          }, a(null == t ? void 0 : t.defaultItem)));
        }
      }, null == t ? void 0 : t.label) : (console.error("No template for " + e + " block exists"), null);
    })));
  }

  function h(n) {
    return A.createElement("div", _m({}, n));
  }

  var a,
      b,
      x,
      y,
      w,
      k,
      E,
      C,
      z,
      I,
      B,
      F,
      N,
      P,
      j = i(d.IconButton).withConfig({
    displayName: "AddBlockButton",
    componentId: "sc-ykvwsj"
  })(b = b || r(["\n  font-family: 'Inter', sans-serif;\n  display: flex;\n  align-items: center;\n\n  &:focus {\n    outline: none !important;\n  }\n\n  svg {\n    transition: all 150ms ease-out;\n  }\n\n  ", ";\n"], ["\n  font-family: 'Inter', sans-serif;\n  display: flex;\n  align-items: center;\n\n  &:focus {\n    outline: none !important;\n  }\n\n  svg {\n    transition: all 150ms ease-out;\n  }\n\n  ", ";\n"]), function (n) {
    return n.isOpen && t.css(a = a || r(["\n      pointer-events: none;\n\n      svg {\n        transform: rotate(45deg);\n      }\n    "], ["\n      pointer-events: none;\n\n      svg {\n        transform: rotate(45deg);\n      }\n    "]));
  }),
      S = i.div.withConfig({
    displayName: "AddBlockWrapper",
    componentId: "sc-ucmgt"
  })(function (n) {
    var e = X(n.offset);
    return t.css(z = z || r(["\n  position: absolute;\n  z-index: calc(var(--tina-z-index-3) - ", ");\n\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  z-index: calc(var(--tina-z-index-3) - ", ");\n\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]), void 0 !== n.index ? n.index : 0, "top" === n.position && t.css(x = x || r(["\n      top: calc(-1 * ", "px);\n      left: 50%;\n      transform: translate3d(-50%, -50%, 0);\n    "], ["\n      top: calc(-1 * ", "px);\n      left: 50%;\n      transform: translate3d(-50%, -50%, 0);\n    "]), nn(e)), "left" === n.position && t.css(y = y || r(["\n      top: 50%;\n      left: calc(-1 * ", "px);\n      transform: translate3d(-50%, -50%, 0);\n    "], ["\n      top: 50%;\n      left: calc(-1 * ", "px);\n      transform: translate3d(-50%, -50%, 0);\n    "]), $(e)), "bottom" === n.position && t.css(w = w || r(["\n      bottom: calc(-1 * ", "px);\n      left: 50%;\n      transform: translate3d(-50%, 50%, 0);\n    "], ["\n      bottom: calc(-1 * ", "px);\n      left: 50%;\n      transform: translate3d(-50%, 50%, 0);\n    "]), nn(e)), "right" === n.position && t.css(k = k || r(["\n      top: 50%;\n      right: calc(-1 * ", "px);\n      transform: translate3d(50%, -50%, 0);\n    "], ["\n      top: 50%;\n      right: calc(-1 * ", "px);\n      transform: translate3d(50%, -50%, 0);\n    "]), $(e)), void 0 === n.position && t.css(E = E || r(["\n      position: relative;\n    "], ["\n      position: relative;\n    "])), n.isOpen && t.css(C = C || r(["\n      z-index: calc(1 + var(--tina-z-index-3) - ", ");\n    "], ["\n      z-index: calc(1 + var(--tina-z-index-3) - ", ");\n    "]), n.index ? n.index : 0));
  }),
      D = i.div.withConfig({
    displayName: "BlocksMenu",
    componentId: "sc-1hpz0g9"
  })(N = N || r(["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid var(--tina-color-grey-2);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  position: absolute;\n  z-index: var(--tina-z-index-2);\n  top: 20px;\n  left: 50%;\n  transform: translate3d(-50%, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 50% 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n\n  ", ";\n\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid var(--tina-color-grey-2);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  position: absolute;\n  z-index: var(--tina-z-index-2);\n  top: 20px;\n  left: 50%;\n  transform: translate3d(-50%, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 50% 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n\n  ", ";\n\n  ", ";\n"]), function (n) {
    return n.isOpen && t.css(I = I || r(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(-50%, 16px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(-50%, 16px, 0) scale3d(1, 1, 1);\n    "]));
  }, function (n) {
    return n.openTop && t.css(F = F || r(["\n      top: auto;\n      bottom: 20px;\n      transform-origin: 50% 100%;\n\n      ", ";\n    "], ["\n      top: auto;\n      bottom: 20px;\n      transform-origin: 50% 100%;\n\n      ", ";\n    "]), n.isOpen && t.css(B = B || r(["\n          transform: translate3d(-50%, -16px, 0) scale3d(1, 1, 1);\n        "], ["\n          transform: translate3d(-50%, -16px, 0) scale3d(1, 1, 1);\n        "])));
  }),
      O = i.button.withConfig({
    displayName: "BlockOption",
    componentId: "sc-vhxzqn"
  })(P = P || r(["\n  all: unset;\n  box-sizing: border-box;\n  color: var(--tina-color-grey-8);\n  font-family: 'Inter', sans-serif;\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-1);\n  padding: 0 12px;\n  height: 34px;\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  user-select: none;\n\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"], ["\n  all: unset;\n  box-sizing: border-box;\n  color: var(--tina-color-grey-8);\n  font-family: 'Inter', sans-serif;\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-1);\n  padding: 0 12px;\n  height: 34px;\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  user-select: none;\n\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"])),
      R = A.createContext(null);

  function J() {
    var n = A.useContext(R);
    if (!n) throw new Error("useInlineBlocks must be within an InlineBlocksContext");
    return n;
  }

  function M(n) {
    var e = n.name,
        t = n.data,
        o = n.block,
        i = n.index,
        r = n.itemProps;
    return A.useMemo(function () {
      return A.createElement(L.Provider, {
        value: _m({
          name: e
        }, o)
      }, A.createElement(o.Component, _m({
        data: t,
        name: e,
        index: i
      }, r)));
    }, [e, JSON.stringify(t), o, i, JSON.stringify(r)]);
  }

  var q,
      T = i.div.withConfig({
    displayName: "BlocksEmptyState",
    componentId: "sc-k1qyxe"
  })(q = q || r(["\n  padding: var(--tina-padding-small);\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  padding: var(--tina-padding-small);\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])),
      U = function U(n) {
    var e = n.name,
        t = n.options,
        o = n.children,
        i = A.useState(!1),
        r = i[0],
        a = i[1],
        l = A.useState(!1),
        c = l[0],
        s = l[1],
        d = _(),
        u = d.focussedField,
        f = d.setFocussedField,
        p = A.useRef(null),
        m = "object" == typeof t ? t.borderRadius : void 0,
        v = "object" == typeof t ? t.offset : void 0,
        g = "object" == typeof t && t.nestedFocus;

    A.useEffect(function () {
      t && e && (a(e === u), s(u.startsWith(e)));
    }, [e, t, u]);
    return A.createElement(V, {
      ref: p,
      active: r,
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault(), !r && e && f(e);
      },
      offset: v,
      borderRadius: m,
      disableHover: !t || c,
      disableChildren: g && !r && !c
    }, "function" == typeof o ? o(r) : o);
  },
      V = i.div.withConfig({
    displayName: "StyledFocusRing",
    componentId: "sc-191xkzj"
  })(function (n) {
    var e = X(n.offset);
    return t.css(Z = Z || r(["\n    position: relative;\n    width: 100%;\n    height: 100%;\n    min-height: var(--tina-font-size-0);\n\n    ", "\n\n    ", "\n\n    &:after {\n      content: '';\n      box-sizing: border-box;\n      display: block;\n      position: absolute;\n      left: calc(-1 * ", "px);\n      top: calc(-1 * ", "px);\n      width: calc(100% + ", "px);\n      height: calc(100% + ", "px);\n      border: 1px solid var(--tina-color-primary);\n      border-radius: ", "px;\n      opacity: 0;\n      pointer-events: none;\n      transition: all var(--tina-timing-medium) ease-out;\n      box-shadow: var(--tina-shadow-big);\n      z-index: var(--tina-z-index-2);\n    }\n\n    ", ";\n  "], ["\n    position: relative;\n    width: 100%;\n    height: 100%;\n    min-height: var(--tina-font-size-0);\n\n    ", "\n\n    ", "\n\n    &:after {\n      content: '';\n      box-sizing: border-box;\n      display: block;\n      position: absolute;\n      left: calc(-1 * ", "px);\n      top: calc(-1 * ", "px);\n      width: calc(100% + ", "px);\n      height: calc(100% + ", "px);\n      border: 1px solid var(--tina-color-primary);\n      border-radius: ", "px;\n      opacity: 0;\n      pointer-events: none;\n      transition: all var(--tina-timing-medium) ease-out;\n      box-shadow: var(--tina-shadow-big);\n      z-index: var(--tina-z-index-2);\n    }\n\n    ", ";\n  "]), !n.disableHover && t.css(Y = Y || r(["\n        &:hover {\n          &:after {\n            opacity: 0.3;\n          }\n        }\n      "], ["\n        &:hover {\n          &:after {\n            opacity: 0.3;\n          }\n        }\n      "])), n.disableChildren && t.css(K = K || r(["\n        > * {\n          pointer-events: none;\n        }\n\n        ", " {\n          opacity: 0;\n          pointer-events: none;\n        }\n      "], ["\n        > * {\n          pointer-events: none;\n        }\n\n        ", " {\n          opacity: 0;\n          pointer-events: none;\n        }\n      "]), T), $(e), nn(e), 2 * $(e), 2 * nn(e), void 0 !== n.borderRadius ? n.borderRadius : "10", n.active && t.css(Q = Q || r(["\n        &:hover:after,\n        &:after {\n          opacity: 1;\n        }\n      "], ["\n        &:hover:after,\n        &:after {\n          opacity: 1;\n        }\n      "])));
  });

  function X(n) {
    var e = 16,
        t = {
      x: 16,
      y: 16
    };
    return "number" == typeof n ? e = n : "object" == typeof n && (t.x = n.x, t.y = n.y, e = t), e;
  }

  var Y,
      K,
      Q,
      Z,
      $ = function $(n) {
    return "object" == typeof n ? n.x : n;
  },
      nn = function nn(n) {
    return "object" == typeof n ? n.y : n;
  },
      en = tn;

  function tn(n) {
    var e = n.name,
        t = n.className,
        o = n.focusRing,
        i = void 0 === o || o,
        r = n.placeholder,
        a = n.children,
        l = W.useCMS();
    return A.createElement(g, {
      name: e
    }, function (n) {
      var e = n.input;
      return l.enabled ? i ? A.createElement(U, {
        name: e.name,
        options: i
      }, A.createElement(rn, _m({
        type: "text"
      }, e, {
        placeholder: r,
        className: t
      }))) : A.createElement(rn, _m({
        type: "text"
      }, e, {
        placeholder: r,
        className: t
      })) : A.createElement(A.Fragment, null, a || e.value);
    });
  }

  var on,
      rn = i.input.withConfig({
    displayName: "Input",
    componentId: "sc-mghuy"
  })(on = on || r(["\n  width: 100%;\n  display: block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  box-sizing: border-box;\n  color: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  max-width: inherit;\n  background-color: inherit;\n  text-align: inherit;\n  outline: none;\n  resize: none;\n  border: none;\n  overflow: visible;\n  position: relative;\n  -ms-overflow-style: none;\n"], ["\n  width: 100%;\n  display: block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  box-sizing: border-box;\n  color: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  max-width: inherit;\n  background-color: inherit;\n  text-align: inherit;\n  outline: none;\n  resize: none;\n  border: none;\n  overflow: visible;\n  position: relative;\n  -ms-overflow-style: none;\n"])),
      an = ln;

  function ln(n) {
    var e = n.name,
        t = n.className,
        o = n.placeholder,
        i = n.children,
        r = n.focusRing,
        a = void 0 === r || r,
        l = W.useCMS();
    return f.createElement(g, {
      name: e
    }, function (n) {
      var e = n.input;
      return l.enabled ? a ? f.createElement(U, {
        name: e.name,
        options: a
      }, f.createElement(sn, _m({
        className: t
      }, e, {
        rows: 1,
        placeholder: o
      }))) : f.createElement(sn, _m({
        className: t
      }, e, {
        rows: 1,
        placeholder: o
      })) : f.createElement(f.Fragment, null, i || e.value);
    });
  }

  var cn,
      sn = i(e).withConfig({
    displayName: "Textarea",
    componentId: "sc-118yp7p"
  })(cn = cn || r(["\n  width: 100%;\n  word-wrap: break-word;\n  display: block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  box-sizing: border-box;\n  color: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  margin: 0 auto;\n  max-width: inherit;\n  background-color: inherit;\n  text-align: inherit;\n  outline: none;\n  resize: none;\n  border: none;\n  overflow: visible;\n  position: relative;\n  -ms-overflow-style: none;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  width: 100%;\n  word-wrap: break-word;\n  display: block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  box-sizing: border-box;\n  color: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  margin: 0 auto;\n  max-width: inherit;\n  background-color: inherit;\n  text-align: inherit;\n  outline: none;\n  resize: none;\n  border: none;\n  overflow: visible;\n  position: relative;\n  -ms-overflow-style: none;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"]));

  function dn(n) {
    var e = n.onDrop,
        t = n.onClick,
        o = n.className,
        i = n.children,
        r = s.useDropzone({
      accept: "image/*",
      onDrop: e,
      noClick: !!t
    }),
        a = r.getRootProps,
        l = r.getInputProps;
    return A.createElement(fn, _m({}, a(), {
      onClick: t,
      className: o
    }), A.createElement("input", _m({}, l())), i);
  }

  var un,
      fn = i.div.withConfig({
    displayName: "Container",
    componentId: "sc-1ghipq7"
  })(un = un || r(["\n  width: inherit;\n  height: inherit;\n"], ["\n  width: inherit;\n  height: inherit;\n"]));

  function pn(n) {
    var e = n.src,
        t = n.alt,
        o = n.className,
        i = n.children;
    return A.createElement(fn, {
      className: o
    }, i ? i({
      src: e
    }) : A.createElement("img", {
      src: e,
      alt: t
    }));
  }

  function mn(n) {
    var e = n.src,
        t = n.alt,
        o = n.className,
        i = n.onClick,
        r = n.onDrop,
        a = n.children;
    return e ? A.createElement(dn, {
      onClick: i,
      onDrop: r,
      className: o
    }, a ? a({
      src: e
    }) : A.createElement("img", {
      src: e,
      alt: t
    })) : A.createElement(dn, {
      onClick: i,
      onDrop: r,
      className: o
    }, A.createElement(gn, null));
  }

  var vn,
      gn = i(function (n) {
    return A.createElement("div", _m({}, n), "Drag 'n' drop some files here,", A.createElement("br", null), "or click to select files");
  }).withConfig({
    displayName: "ImagePlaceholder",
    componentId: "sc-1ee2j0w"
  })(vn = vn || r(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  input:active,\n  input:focus {\n    outline: none;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  input:active,\n  input:focus {\n    outline: none;\n  }\n"]));

  function hn(n) {
    var i = n.form,
        r = n.input,
        e = n.name,
        t = n.previewSrc,
        a = n.uploadDir,
        o = n.children,
        l = n.focusRing,
        c = void 0 === l || l,
        s = n.alt,
        d = void 0 === s ? "" : s,
        u = n.className,
        f = W.useCMS(),
        p = W.usePreviewSrc(r.value, e, i.values, t)[0];
    return A.createElement(U, {
      name: e,
      options: c
    }, A.createElement(mn, {
      src: p,
      alt: d,
      onDrop: function onDrop(n) {
        var o = n[0];
        return function (r, a, l, c) {
          return new (l = l || Promise)(function (n, e) {
            function t(n) {
              try {
                i(c.next(n));
              } catch (n) {
                e(n);
              }
            }

            function o(n) {
              try {
                i(c.throw(n));
              } catch (n) {
                e(n);
              }
            }

            function i(e) {
              e.done ? n(e.value) : new l(function (n) {
                n(e.value);
              }).then(t, o);
            }

            i((c = c.apply(r, a || [])).next());
          });
        }(this, void 0, void 0, function () {
          var e, t;
          return v(this, function (n) {
            switch (n.label) {
              case 0:
                return e = a ? a(i.values) : "", [4, f.media.persist([{
                  directory: e,
                  file: o
                }])];

              case 1:
                return (t = n.sent()[0]) && r.onChange(t), [2, null];
            }
          });
        });
      },
      onClick: function onClick() {
        var n = a ? a(i.values) : "";
        f.media.open({
          allowDelete: !0,
          directory: n,
          onSelect: function onSelect(n) {
            n.filename == r.value && r.onChange(""), r.onChange(n);
          }
        });
      },
      className: u
    }, o));
  }

  var bn = xn;

  function xn(o) {
    var i = W.useCMS();
    return A.createElement(g, {
      name: o.name,
      parse: o.parse
    }, function (n) {
      var e = n.input,
          t = n.form;
      return i.enabled ? A.createElement(hn, _m({}, o, {
        input: e,
        form: t
      })) : A.createElement(pn, {
        children: o.children,
        src: e.value,
        alt: o.alt,
        className: o.className
      });
    });
  }

  var yn,
      wn,
      kn,
      En,
      Cn,
      zn,
      In,
      Bn,
      Fn,
      Nn,
      Pn,
      jn = i.div.withConfig({
    displayName: "AddBlockMenuWrapper",
    componentId: "sc-80kg9x"
  })(function (n) {
    return t.css(wn = wn || r(["\n    opacity: 0;\n    transition: all var(--tina-timing-medium) ease-out;\n    pointer-events: none;\n\n    ", "\n  "], ["\n    opacity: 0;\n    transition: all var(--tina-timing-medium) ease-out;\n    pointer-events: none;\n\n    ", "\n  "]), n.active && t.css(yn = yn || r(["\n        opacity: 1;\n        pointer-events: all;\n      "], ["\n        opacity: 1;\n        pointer-events: all;\n      "])));
  }),
      Sn = i.div.withConfig({
    displayName: "BlockMenuWrapper",
    componentId: "sc-1w0z2b"
  })(function (n) {
    var e = X(n.offset);
    return t.css(Cn = Cn || r(["\n    position: absolute;\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n    top: calc(-1 * ", "px - 16px);\n    right: calc(-1 * ", "px - 1px);\n    left: calc(-1 * ", "px - 1px);\n    opacity: 0;\n    transition: all var(--tina-timing-medium) ease-out;\n    z-index: calc(var(--tina-z-index-1) - ", ");\n    pointer-events: none;\n    transform: translate3d(0, -100%, 0);\n\n    ", "\n\n    ", "\n  "], ["\n    position: absolute;\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n    top: calc(-1 * ", "px - 16px);\n    right: calc(-1 * ", "px - 1px);\n    left: calc(-1 * ", "px - 1px);\n    opacity: 0;\n    transition: all var(--tina-timing-medium) ease-out;\n    z-index: calc(var(--tina-z-index-1) - ", ");\n    pointer-events: none;\n    transform: translate3d(0, -100%, 0);\n\n    ", "\n\n    ", "\n  "]), nn(e), $(e), $(e), n.index ? n.index : 0, n.inset && t.css(kn = kn || r(["\n        top: calc(14px - ", "px);\n        left: calc(14px - ", "px);\n        right: calc(14px - ", "px);\n        transform: translate3d(0, 0, 0);\n      "], ["\n        top: calc(14px - ", "px);\n        left: calc(14px - ", "px);\n        right: calc(14px - ", "px);\n        transform: translate3d(0, 0, 0);\n      "]), nn(e), $(e), $(e)), n.active && t.css(En = En || r(["\n        opacity: 1;\n      "], ["\n        opacity: 1;\n      "])));
  }),
      Dn = i.div.withConfig({
    displayName: "BlockMenuSpacer",
    componentId: "sc-a2xvzn"
  })(zn = zn || r(["\n  pointer-events: none;\n  visibility: hidden;\n  flex: 1 0 var(--tina-padding-small);\n"], ["\n  pointer-events: none;\n  visibility: hidden;\n  flex: 1 0 var(--tina-padding-small);\n"])),
      On = i.div.withConfig({
    displayName: "BlockLabel",
    componentId: "sc-13te162"
  })(In = In || r(["\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  z-index: var(--tina-z-index-1);\n  pointer-events: none;\n  font-family: var(--tina-font-family);\n  font-size: var(--tina-font-size-1);\n  background-color: white;\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-big);\n  border: 1px solid var(--tina-color-grey-2);\n  padding: 0 var(--tina-padding-small);\n  color: var(--tina-color-grey-8);\n  font-weight: 500;\n"], ["\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  z-index: var(--tina-z-index-1);\n  pointer-events: none;\n  font-family: var(--tina-font-family);\n  font-size: var(--tina-font-size-1);\n  background-color: white;\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-big);\n  border: 1px solid var(--tina-color-grey-2);\n  padding: 0 var(--tina-padding-small);\n  color: var(--tina-color-grey-8);\n  font-weight: 500;\n"])),
      Rn = i.div.withConfig({
    displayName: "BlockMenu",
    componentId: "sc-n4asgd"
  })(Bn = Bn || r(["\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: row;\n  position: relative;\n  top: 0;\n  background-color: white;\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-big);\n  border: 1px solid var(--tina-color-grey-2);\n  overflow: hidden;\n  pointer-events: all;\n"], ["\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: row;\n  position: relative;\n  top: 0;\n  background-color: white;\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-big);\n  border: 1px solid var(--tina-color-grey-2);\n  overflow: hidden;\n  pointer-events: all;\n"])),
      Mn = i.div.withConfig({
    displayName: "BlockAction",
    componentId: "sc-1buqlss"
  })(Pn = Pn || r(["\n  background-color: ", ";\n  color: ", ";\n  fill: ", ";\n  outline: none;\n  border: none;\n  padding: 4px 6px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n\n  &:hover {\n    background-color: rgba(53, 50, 50, 0.09);\n  }\n  &:active {\n    color: var(--tina-color-primary);\n    fill: var(--tina-color-primary);\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  &:not(:last-child) {\n    border-right: 1px solid var(--tina-color-grey-2);\n  }\n  svg {\n    width: 26px;\n    height: auto;\n  }\n\n  ", ";\n\n  ", ";\n"], ["\n  background-color: ", ";\n  color: ", ";\n  fill: ", ";\n  outline: none;\n  border: none;\n  padding: 4px 6px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n\n  &:hover {\n    background-color: rgba(53, 50, 50, 0.09);\n  }\n  &:active {\n    color: var(--tina-color-primary);\n    fill: var(--tina-color-primary);\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  &:not(:last-child) {\n    border-right: 1px solid var(--tina-color-grey-2);\n  }\n  svg {\n    width: 26px;\n    height: auto;\n  }\n\n  ", ";\n\n  ", ";\n"]), function (n) {
    return n.active ? "rgba(53, 50, 50, 0.05)" : "transparent";
  }, function (n) {
    return n.active ? "var(--tina-color-primary)" : "var(--tina-color-grey-8)";
  }, function (n) {
    return n.active ? "var(--tina-color-primary)" : "var(--tina-color-grey-8)";
  }, function (n) {
    return n.active && t.css(Fn = Fn || r(["\n      color: var(--tina-color-primary);\n      fill: var(--tina-color-primary);\n      background-color: rgba(53, 50, 50, 0.05);\n    "], ["\n      color: var(--tina-color-primary);\n      fill: var(--tina-color-primary);\n      background-color: rgba(53, 50, 50, 0.05);\n    "]));
  }, function (n) {
    return n.disabled && t.css(Nn = Nn || r(["\n      pointer-events: none;\n      color: #d1d1d1;\n      fill: #d1d1d1;\n    "], ["\n      pointer-events: none;\n      color: #d1d1d1;\n      fill: #d1d1d1;\n    "]));
  });

  function qn(n) {
    var e = n.fields,
        t = A.useState(!1),
        o = t[0],
        i = t[1];
    return !(e && e.length) ? null : A.createElement(A.Fragment, null, A.createElement(Mn, {
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault(), i(!o);
      }
    }, A.createElement(H.EditIcon, null)), o && A.createElement(Tn, {
      fields: e,
      close: function close() {
        return i(!1);
      }
    }));
  }

  function Tn(n) {
    var e = n.title,
        t = void 0 === e ? "Settings" : e,
        o = n.fields,
        i = n.close,
        r = _().form,
        a = A.useContext(L).name,
        l = A.useState(r.values)[0];

    var c = o;
    a && (c = o.map(function (n) {
      return _m(_m({}, n), {
        name: a + "." + n.name
      });
    }));
    var s = A.useCallback(function (n) {
      if (n.destination && r) {
        var e = n.type;
        r.mutators.move(e, n.source.index, n.destination.index);
      }
    }, [r]);
    return A.createElement(W.Modal, {
      id: "tinacms-inline-settings",
      onClick: function onClick(n) {
        return n.stopPropagation();
      }
    }, A.createElement(W.ModalPopup, null, A.createElement(W.ModalHeader, {
      close: i
    }, t), A.createElement(W.ModalBody, null, A.createElement(u.DragDropContext, {
      onDragEnd: s
    }, A.createElement(Hn, null, A.createElement(_n, null, A.createElement(W.FieldsBuilder, {
      form: r,
      fields: c
    }))))), A.createElement(W.ModalActions, null, A.createElement(d.Button, {
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault(), r.updateValues(l), i();
      }
    }, "Cancel"), A.createElement(d.Button, {
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault(), i();
      },
      disabled: r.values === l,
      primary: !0
    }, "Confirm"))));
  }

  var An,
      Wn,
      Hn = i(o.FormPortalProvider).withConfig({
    displayName: "FormBody",
    componentId: "sc-19xk7pz"
  })(An = An || r(["\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: auto;\n  border-top: 1px solid var(--tina-color-grey-2);\n  background-color: #f6f6f9;\n"], ["\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: auto;\n  border-top: 1px solid var(--tina-color-grey-2);\n  background-color: #f6f6f9;\n"])),
      _n = i.div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-n4aiot"
  })(Wn = Wn || r(["\n  display: block;\n  margin: 0 auto;\n  width: 100%;\n"], ["\n  display: block;\n  margin: 0 auto;\n  width: 100%;\n"]));

  function Ln(n) {
    var e = n.name,
        t = n.children,
        o = n.insetControls,
        i = n.focusRing,
        r = void 0 === i ? {} : i,
        a = W.useCMS(),
        l = A.useRef(null),
        c = A.useContext(L).fields,
        s = A.useState(!1),
        d = s[0],
        u = s[1],
        f = A.useState(!1),
        p = f[0],
        m = f[1],
        v = _(),
        g = v.focussedField,
        h = v.setFocussedField,
        b = A.useRef(null),
        x = "object" == typeof r ? r.borderRadius : void 0,
        y = "object" == typeof r ? r.offset : void 0;

    A.useEffect(function () {
      r && e && (u(e === g), m(g.startsWith(e)));
    }, [e, r, g]);
    return a.disabled ? t : A.createElement(V, {
      ref: b,
      active: r && d,
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault(), !d && e && h(e);
      },
      offset: y,
      borderRadius: x,
      disableHover: !1 === r || p,
      disableChildren: !d && !p
    }, A.createElement(Sn, {
      ref: l,
      offset: y,
      inset: o,
      active: d
    }, A.createElement(Dn, null), A.createElement(Rn, null, A.createElement(qn, {
      fields: c
    }))), t);
  }

  var Gn = g;
  n.AddBlockMenu = G, n.BlockAction = Mn, n.BlockField = Gn, n.BlockImage = function (n) {
    return A.createElement(xn, _m({}, n, {
      focusRing: !1
    }));
  }, n.BlockLabel = On, n.BlockMenu = Rn, n.BlockMenuSpacer = Dn, n.BlockMenuWrapper = Sn, n.BlockText = function (n) {
    return A.createElement(tn, _m({}, n, {
      focusRing: !1
    }));
  }, n.BlockTextarea = function (n) {
    return A.createElement(ln, _m({}, n, {
      focusRing: !1
    }));
  }, n.BlocksControls = function (n) {
    var e = n.children,
        t = n.index,
        o = n.insetControls,
        i = n.label,
        r = void 0 === i || i,
        a = n.focusRing,
        l = void 0 === a ? {} : a,
        c = n.customActions,
        s = void 0 === c ? [] : c,
        d = W.useCMS(),
        u = _(),
        f = u.focussedField,
        p = u.setFocussedField,
        m = A.useContext(L),
        v = m.name,
        g = m.template,
        h = J(),
        b = h.insert,
        x = h.duplicate,
        y = h.move,
        w = h.remove,
        k = h.blocks,
        E = h.count,
        C = h.direction,
        z = h.min,
        I = h.max,
        B = 0 === t,
        F = t === E - 1,
        N = A.useRef(null),
        P = A.useRef(null),
        j = A.useRef(null),
        S = "horizontal" === C ? "left" : "top",
        D = "horizontal" === C ? "right" : "bottom";

    if (d.disabled) return A.createElement(A.Fragment, null, e);
    var O = v === f,
        R = f.startsWith(v),
        M = "object" == typeof l ? l.offset : void 0,
        q = "object" == typeof l ? l.borderRadius : void 0;

    function T(n) {
      return !n || !(n === E || I === E && z === E);
    }

    return A.createElement(V, {
      active: l && O,
      onClick: function onClick(n) {
        var e, t, o;
        n.stopPropagation(), n.preventDefault(), (null === (e = N.current) || void 0 === e ? void 0 : e.contains(n.target)) || (null === (t = P.current) || void 0 === t ? void 0 : t.contains(n.target)) || (null === (o = j.current) || void 0 === o ? void 0 : o.contains(n.target)) || p(v);
      },
      offset: M,
      borderRadius: q,
      disableHover: !1 === l || R,
      disableChildren: !O && !R
    }, O && A.createElement(A.Fragment, null, T(I) && A.createElement(jn, {
      active: O
    }, A.createElement(G, {
      addBlock: function addBlock(n) {
        return b(t, n);
      },
      blocks: k,
      index: t,
      offset: M,
      position: S
    }), A.createElement(G, {
      addBlock: function addBlock(n) {
        return b(t + 1, n);
      },
      blocks: k,
      index: t,
      offset: M,
      position: D
    })), A.createElement(Sn, {
      offset: M,
      ref: N,
      index: t,
      active: O,
      inset: o
    }, r && A.createElement(On, null, g.label), A.createElement(Dn, null), A.createElement(Rn, null, A.createElement(Mn, {
      ref: P,
      onClick: function onClick(n) {
        y(t, t - 1), n.stopPropagation(), n.preventDefault();
      },
      disabled: B
    }, "vertical" === C && A.createElement(H.ChevronUpIcon, null), "horizontal" === C && A.createElement(H.ChevronLeftIcon, null)), A.createElement(Mn, {
      ref: j,
      onClick: function onClick(n) {
        y(t, t + 1), n.stopPropagation(), n.preventDefault();
      },
      disabled: F
    }, "vertical" === C && A.createElement(H.ChevronDownIcon, null), "horizontal" === C && A.createElement(H.ChevronRightIcon, null)), s.map(function (n, e) {
      return A.createElement(Mn, {
        key: e,
        onClick: function onClick() {
          return n.onClick();
        }
      }, n.icon);
    }), T(I) && A.createElement(Mn, {
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault(), x(t, t + 1);
      }
    }, A.createElement(H.DuplicateIcon, null)), A.createElement(qn, {
      fields: g.fields
    }), T(z) && A.createElement(Mn, {
      onClick: function onClick(n) {
        n.stopPropagation(), n.preventDefault(), w(t);
      }
    }, A.createElement(H.TrashIcon, null))))), e);
  }, n.BlocksEmptyState = T, n.FocusRing = U, n.InlineBlock = M, n.InlineBlocks = function (n) {
    var e = n.name,
        l = n.blocks,
        t = n.className,
        c = void 0 === t ? "" : t,
        o = n.direction,
        s = void 0 === o ? "vertical" : o,
        d = n.itemProps,
        u = n.min,
        f = n.max,
        i = n.components,
        p = void 0 === i ? {} : i,
        m = W.useCMS(),
        v = _().setFocussedField;

    return A.createElement(g, {
      name: e
    }, function (n) {
      function e(n, e) {
        o.mutators.insert(r, n, e), v(r + "." + n);
      }

      var i = n.input,
          o = n.form,
          r = i.name,
          t = i.value || [],
          a = p.Container || h;
      return A.createElement(a, {
        className: c
      }, A.createElement(R.Provider, {
        value: {
          insert: e,
          duplicate: function duplicate(n, e) {
            o.mutators.insert(r, e, t[n]), v(r + "." + e);
          },
          move: function move(n, e) {
            o.mutators.move(r, n, e), v(r + "." + e);
          },
          remove: function remove(n) {
            o.mutators.remove(r, n);
            var e = 1 === i.value.length,
                t = i.value.length - 1 === n;
            v(e ? "" : t ? i.name + "." + (n - 1) : i.name + "." + n);
          },
          blocks: l,
          count: t.length,
          direction: s,
          min: u,
          max: f
        }
      }, t.length < 1 && m.enabled && A.createElement(T, null, A.createElement(G, {
        addBlock: function addBlock(n) {
          return e(0, n);
        },
        blocks: l
      })), t.map(function (n, e) {
        var t = l[n._template];
        if (!t) return console.warn("Unrecognized Block of type:", n._template), null;
        var o = i.name + "." + e;
        return A.createElement(M, {
          itemProps: d,
          key: e,
          index: e,
          name: o,
          data: n,
          block: t
        });
      })));
    });
  }, n.InlineBlocksContext = R, n.InlineField = g, n.InlineFieldContext = L, n.InlineForm = function (n) {
    var e = n.form,
        t = n.children,
        o = A.useState(""),
        i = o[0],
        r = o[1],
        a = A.useMemo(function () {
      return {
        form: e,
        focussedField: i,
        setFocussedField: r
      };
    }, [e, i, r]);
    return A.createElement(p.Provider, {
      value: a
    }, A.createElement(l.Dismissible, {
      disabled: !i,
      click: !0,
      allowClickPropagation: !0,
      onDismiss: function onDismiss() {
        document.getElementById("tinacms-inline-settings") || r("");
      }
    }, A.createElement("div", {
      onClick: function onClick() {
        return r("");
      }
    }, A.createElement(W.FormBuilder, {
      form: e
    }, function (n) {
      n.form;

      var e = function (n, e) {
        var t = {};

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && e.indexOf(o) < 0 && (t[o] = n[o]);
        }

        if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
          var i = 0;

          for (o = Object.getOwnPropertySymbols(n); i < o.length; i++) {
            e.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(n, o[i]) && (t[o[i]] = n[o[i]]);
          }
        }

        return t;
      }(n, ["form"]);

      return "function" != typeof t ? t : t(_m(_m({}, e), a));
    }))));
  }, n.InlineFormContext = p, n.InlineGroup = function (n) {
    var e = n.name,
        t = n.children,
        o = n.fields,
        i = void 0 === o ? [] : o,
        r = n.insetControls,
        a = n.focusRing,
        l = e,
        c = A.useContext(L);
    return c.name && (l = c.name + "." + e), A.createElement(L.Provider, {
      value: {
        name: l,
        fields: i
      }
    }, A.createElement(Ln, {
      name: l,
      insetControls: r,
      focusRing: a
    }, t));
  }, n.InlineGroupControls = Ln, n.InlineImage = xn, n.InlineImageField = bn, n.InlineSettings = qn, n.InlineText = tn, n.InlineTextField = en, n.InlineTextarea = ln, n.InlineTextareaField = an, n.StyledFocusRing = V, n.getOffset = X, n.getOffsetX = $, n.getOffsetY = nn, n.useInlineBlocks = J, n.useInlineForm = _, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});